import React, { useRef, useState, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import ButtonWrapper from "../../components/Button";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { FaFilePdf } from "react-icons/fa";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { addFormMTDoc } from "@egovernments/digit-ui-module-core/src/redux/actions/formMT";
import { InfoBox } from "../../components/StyledComponent";
import { Loader } from "@egovernments/digit-ui-react-components";

const Step4 = ({ formData, handleTabChange, isEmployee, isNocModule }) => {
  const { t } = useTranslation();
  const { handleSubmit, control, setValue, watch, reset } = useForm({});
  const tenantId = Digit.ULBService.getStateId();
  const drawingPdf = formData?.documents?.filter((e) => e.documentType === "drawingPdf") || [];
  const [drawingDetail, setDrawingDetail] = useState(drawingPdf || []);
  const [open, setOpen] = useState(false);
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState("");
  const [currentDocumentIndex, setCurrentDocumentIndex] = useState(null);
  const [signingParams, setSigningParams] = useState({
    AuthToken: "",
    SrcPdfB64: "",
    SignSettingName: "",
    ReturnUrl: "",
    UserDataJson: "",
  });
  const [loading, setLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [savedFileStoreId, setSavedFileStoreId] = useState(null);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const formRef = useRef(null);
  console.log(drawingDetail, formData?.documents, drawingPdf, "drawingDetail");

  const onSubmit = () => {
    OpenPDFFromB64InPdfViewer();
  };
  const validatePdfUrl = (url) => {
    try {
      const urlObj = new URL(url);
      console.log("PDF URL validation:", {
        protocol: urlObj.protocol,
        hostname: urlObj.hostname,
        pathname: urlObj.pathname,
        search: urlObj.search,
        isValid: true,
      });
      return true;
    } catch (error) {
      console.error("Invalid PDF URL:", url, error);
      return false;
    }
  };
  const handleOpenPdf = async (url, index = null) => {
    console.log("DEBUG: handleOpenPdf called with URL:", url);
    // Validate URL before setting it
    if (!validatePdfUrl(url)) {
      showMessage("Invalid PDF URL provided", "error");
      return;
    }
    setCurrentPdfUrl(url);
    setCurrentDocumentIndex(index);
    setPdfModalOpen(true);
    console.log("DEBUG: PDF modal opened");
  };

  const columns = [
    { id: "submissionIndex", label: "Submission", accessor: "" },
    { id: "viewPdf", label: "View Drawing", accessor: "documentType" },
    // { id: "signedPdfUrl", label: "Digital Sign", accessor: "url" },
  ];
  const handleClose = () => {
    setOpen(false);
  };

  const handleSign = async () => {
    setLoading(true);
    try {
      const SignRequest = {
        applicationNo: formData?.applicationNo,
        pdfType: "FAR",
      };
      const getSign = await Digit.DscService.getSignParams({ SignRequest });
      setSigningParams((prev) => ({
        ...prev,
        AuthToken: getSign?.SigningParameters?.authToken,
        SrcPdfB64: getSign?.SigningParameters?.pdfBase64,
        SignSettingName: getSign?.SigningParameters?.signSettingName,
        ReturnUrl: getSign?.SigningParameters?.returnURL,
        UserDataJson: getSign?.SigningParameters?.UserDataJson,
      }));
      setOpen(true);
      setLoading(false);
    } catch (error) {
      console.error(error, "error");
    }
  };
  const getFileStoreId = (url) => {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.searchParams.get("fileStoreId");
    } catch (error) {
      console.error("Invalid URL:", error);
      return null;
    }
  };

  const OpenPDFFromB64InPdfViewer = () => {
    const { AuthToken, SrcPdfB64 } = signingParams;
    if (!AuthToken || !SrcPdfB64) {
      alert("Please ensure both Bearer Token and PDF Base64 are provided.");
      return;
    }
    formRef.current.setAttribute("action", "https://digital.abmapplication.com/Console/PdfViewerSigning");
    formRef.current.submit();
  };
  if (loading || isPreviewLoading) {
    return <Loader />;
  }
  return (
    <section className="groupContainer">
      <form ref={formRef}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Drawing")}</h2>
          </div>
        </div>
        <InfoBox style={{ fontSize: "14px", margin: "10px" }}>
          I hereby declare that the map has been prepared as per the prevailing building byelaws and the map has been duly digitally signed by me.
        </InfoBox>
        <TableContainer component={Paper} sx={{ marginBottom: "20px" }}>
          <Table sx={{ minWidth: 650 }} aria-label="drawing details  table">
            <TableHead
              sx={{
                backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C",
                color: "#fff",
              }}
            >
              <TableRow sx={{ height: "20px" }}>
                {columns.map((column) => (
                  <TableCell key={column.id} sx={{ color: "#fff" }}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {drawingPdf?.map((row, index) => (
                <TableRow key={index}>
                  {/* Column 1 - Submission Index */}
                  <TableCell>Submission {index + 1}</TableCell>

                  {/* Column 2 - View PDF */}
                  <TableCell>
                    {row?.fileStoreId ? (
                      <FaFilePdf
                        color="#a10505"
                        style={{
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                        }}
                        onClick={() => getDocumentByFileStoreId(row.fileStoreId, setIsPreviewLoading)}
                      />
                    ) : (
                      "N/A"
                    )}
                  </TableCell>

                  {/* Column 3 - Attach Digital Signature */}
                  {/* <TableCell>
                    {formData?.signedDrawingPdfId ? (
                      <FaFilePdf
                        color="#a10505"
                        style={{
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                        }}
                        onClick={() => getDocumentByFileStoreId(formData?.signedDrawingPdfId, setIsPreviewLoading)}
                      />
                    ) : (
                      <ButtonWrapper variant="outlined" color="primary" size="small" label="Attach Signature" type="button" onClick={handleSign} />
                    )}
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          style={{
            display: open ? "block" : "none",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              padding: "20px",
              background: "#fff",
              borderRadius: "5px",
              boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            }}
          >
            <p style={{ margin: "15px" }}>By clicking on the Submit button, you will be redirected to the Third-Party Page.</p>
            <form
              id="PDFViewerDemo"
              method="POST"
              //target="_blank"
              ref={(el) => (formRef.current = el)}
              onSubmit={handleSubmit(onSubmit)}
              action="https://digital.abmapplication.com/Console/PdfViewerSigning"
            >
              <input type="hidden" id="AuthToken" name="AuthToken" value={signingParams.AuthToken} />
              <input type="hidden" id="SignSettingName" name="SignSettingName" value={signingParams.SignSettingName} />
              <input type="hidden" id="SrcPdfB64" name="SrcPdfB64" value={signingParams.SrcPdfB64} />
              <input type="hidden" id="SrcPdfPath" name="SrcPdfPath" value="" />
              <input type="hidden" id="SignedPdfPath" name="SignedPdfPath" value="" />
              <input type="hidden" id="UserDataJson" name="UserDataJson" value={signingParams.UserDataJson} />
              <input
                type="hidden"
                id="ReturnUrl"
                name="ReturnUrl"
                value={signingParams.ReturnUrl || "https://cors.signer.digital/Home/PdfViewerSignResponse"}
              />

              <div class="button-inline">
                <div style={{ textAlign: "right" }}>
                  <button
                    type="button"
                    onClick={handleClose}
                    style={{ backgroundColor: "#0E7693", color: "#fff", marginLeft: "10px", padding: "5px", borderRadius: "3px" }}
                  >
                    Cancel
                  </button>
                  <button
                    value="Submit"
                    type="submit"
                    onClick={OpenPDFFromB64InPdfViewer}
                    style={{ backgroundColor: "#0E7693", color: "#fff", marginLeft: "10px", padding: "5px", borderRadius: "3px" }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="success"
              size="medium"
              label="Save"
              type="button"
              onClick={() => handleTabChange(3)}
              sx={{ backgroundColor: "#157CB3" }}
            />
          </div>
        </div>
      </form>
    </section>
  );
};
1;

export default Step4;
